var currentRequestIdleCallback = window.requestIdleCallback || function (callback) {
    return setTimeout(callback, 0);
};

var currentCancelIdleCallback = window.cancelIdleCallback || function (requestId) {
    return clearTimeout(requestId);
};

export var request = function request(callback) {
    return currentRequestIdleCallback(callback);
};
export var cancel = function cancel(requestId) {
    return currentCancelIdleCallback(requestId);
};